import { CurrentEditors } from "./CurrentEditors";
import { DocumentSummary } from "./DocumentSummary";

export class SingleEntryCheckInformation {
  registeredDocumentSummary: DocumentSummary;
  editInformation: CurrentEditors;
}
